export const getEidError = () => {
  return (dispatch, getState, { api }) => {
    return api.getEidError().then(
      ({ result }) => {
        return { wasSuccessful: true, errors: result.errors };
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
